// extracted by mini-css-extract-plugin
export var active = "_2m-2";
export var container = "_2m-0";
export var expired = "_2m-3";
export var hasStatus = "_2m-4";
export var statusChip = "_2m-1";